module.exports = __webpack_public_path__ + "img/newsHomeAdBlack.30cbd915.png";